import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { TypographyLarge } from "../../../customComponent";
import LayerAssetItem from "./LayerAssetItem";
import { colorStyling } from "../../../../helpers/color";
import parser from "html-react-parser";
import {
  getAssetData,
  setGroupChildIndex,
} from "../../../../store/actions/cmsAction";
import { logger } from "../../../../helpers/logger";

const ContentPreview = ({
  open,
  loading,
  content,
  layers,
  canvasRes,
  ratiodRes,
  refreshed,
  disableControl,
}) => {
  const dispatch = useDispatch();
  const { groupChildIndex } = useSelector((state) => state.cms);

  const { t } = useTranslation("cms");
  const { user } = useSelector((state) => state.auth);
  const permission = user?.permission;

  useEffect(() => {
    if (!open || layers.length === 0) {
      dispatch(setGroupChildIndex({}));
      return;
    }

    const initGroupIndex = {};
    layers.forEach((layer, i) => {
      dispatch(
        getAssetData(layer.id, layer.assets, true, (results) => {
          logger.log(`getAssetData-callback:`, results);
          const assetIDs = Object.keys(results);

          // Parsing specific type assets
          for (let j = 0; j < assetIDs.length; j++) {
            const asset = results[assetIDs[j]];
            switch (asset.type) {
              case "GROUPED":
                if (!initGroupIndex[layer.id]) {
                  initGroupIndex[layer.id] = {};
                }
                initGroupIndex[layer.id][asset.id] = 0;
                break;

              default:
                break;
            }
          }
        })
      );
    });

    dispatch(setGroupChildIndex(initGroupIndex));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, layers]);

  const handleUpdateGroupChildIndex = (layerID, updatedIndex) => {
    const updated = { ...groupChildIndex };
    updated[layerID] = updatedIndex;
    logger.log(`handleUpdateGroupChildIndex:`, updated);
    dispatch(setGroupChildIndex(updated));
  };

  return (
    <>
      <Box
        id={"preview-box"}
        sx={{
          pl: 1,
          pb: 2,
          pt: 2,
          pr: 4,
          width: "fit-content",
        }}
      >
        {!loading && (
          <Box
            boxShadow={1}
            sx={{
              width: canvasRes.width + 1,
              height: canvasRes.height + 1,
              position: "relative",
              backgroundColor: colorStyling.black,
              border: "1px solid rgba(28, 78, 216, 0.5)",
            }}
          >
            {permission?.asset?.read ? (
              layers.map((layer, i) => {
                return (
                  <LayerAssetItem
                    key={i}
                    index={i}
                    layer={layer}
                    canvasRes={canvasRes}
                    contentRes={{
                      width: content.width,
                      height: content.height,
                    }}
                    ratiodRes={ratiodRes}
                    open={open}
                    refreshed={refreshed}
                    disableControl={disableControl}
                    groupChildIndex={groupChildIndex[layer.id]}
                    setGroupChildIndex={(layerID, update) =>
                      handleUpdateGroupChildIndex(layerID, update)
                    }
                  />
                );
              })
            ) : (
              <Box sx={{ height: "100%", alignContent: "center" }}>
                <TypographyLarge
                  sx={{
                    fontWeight: 400,
                    color: colorStyling.primary,
                    textAlign: "center",
                  }}
                >
                  {parser(t("detail.noPermissionHint"))}
                </TypographyLarge>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};

export default ContentPreview;
